
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BackdropScreen } from "../../components";
import { CarritoVacio } from "../../compras/components";
import { Button, Grid, Paper } from "@mui/material";
import { PagoOrdenOp } from "../../compras/views";
import { separadorMillares, usePrecioCarritoXRole } from "../../../hooks";
import { useQueryClient } from "@tanstack/react-query";
import { useAuthStore, useCarritoClienteStore, useFormOpStore, useGlobalValueStore, useUsuariosStore } from "../../../stores";
import { LayoutCrearDoc } from "../../layouts";
import { roleCompra } from "../../../data";
import { CardsComprarAhoraCliente } from "../components";
import { useListCarritoXUser } from "../../../hooks/cache";
import { startComprarOPCliente } from "../../../services";


import Swal from "sweetalert2";





export const ComprarAhoraCliente = () => {

    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { cliente } = useAuthStore();
    const { data } = useListCarritoXUser(cliente?.id);
    const { items, limpiarItems } = useCarritoClienteStore();
    const itemsClienteCarrito = (cliente) ? data : items;

    const { iva, view, cambiarIva, cambioRolVenta } = useGlobalValueStore();
    const { precioTotalSegunRol, obtenerPreciosCarritoIva } = usePrecioCarritoXRole();
    const { formOp, resetForm, setFormOp } = useFormOpStore();
    const titulo = (view) ? `Venta realizada a ${view}` : 'Por favor seleccione tipo de cliente';
    const [cargando, setCargando] = useState(false);
    

    
    useEffect(() => {
        if(!itemsClienteCarrito || itemsClienteCarrito.length < 1) return;
        const precios = obtenerPreciosCarritoIva(itemsClienteCarrito);
        if(precios) {
            setFormOp({
                view: view,
                totalCliente: precios.cliente,
                totalDistri: precios.distri,
                totalPublicista: precios.publicista,
                totalEmpresa: precios.empresa,
                totalOrden: precios.totalView,
                iva: precios.valorIVA,
                quienCompra: cliente?.id || null,
            });
        }
    }, [itemsClienteCarrito, iva, view, cliente?.id]);



    const handleCrearOpCliente = async() => {
        const { isConfirmed } = await Swal.fire({
            title: 'Hacer compra',
            text: `¿Está seguro de realizar esta compra?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Sí, Realizar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
        });

        if(!isConfirmed) return;

        setCargando(true);
        const resp = await startComprarOPCliente(formOp);
        setCargando(false);
        if( resp ) { 
            await queryClient.invalidateQueries({ queryKey: ['carritoxuser'] });
            resetForm();
            cambiarIva(false);
            cambioRolVenta(null);
            limpiarItems();
        }
    }    




    return (
        <LayoutCrearDoc titulo='Pagar Orden' subtitulo={titulo} add={false} pt={4} px={5} pb={2}>
            <BackdropScreen cargando={cargando} titulo='Espere por favor estamos generando su orden de pedido...' />

            {(itemsClienteCarrito?.length > 0)
            ?   <Grid container mt={5}>
                    <Grid item xs={12} md={7} sx={{ pr:{xs:0, md:3}, alignSelf:"flex-start"}}>
                        <CardsComprarAhoraCliente
                            carritoCompra={itemsClienteCarrito || []} 
                            urlCotiz="/super/cotizacion" 
                        />

                        <Paper sx={{mt:2, p:2, height:'50px', display:'flex', alignItems:'center', justifyContent:'end'}}>
                            { `Total ${roleCompra[view]}: $${ separadorMillares(precioTotalSegunRol(itemsClienteCarrito)) }` }
                        </Paper>
                    </Grid>

                    <Grid item xs={12} md={5} sx={{mt:{xs:5, md:0},}}>

                        <Grid item xs={12} sx={{ p:2, background:'#1E1E1E', borderRadius:'10px', alignSelf:"flex-start"}}>
                            <PagoOrdenOp data={itemsClienteCarrito} />
                            {( cliente ) 
                            ?   <Grid item xs={12} sx={{mt:2}}>
                                    <Button fullWidth color='secondary' variant="contained" onClick={ handleCrearOpCliente }>
                                        Completar Orden
                                    </Button>
                                </Grid>  

                            :    <Grid item xs={12}>
                                    <Button fullWidth color='primary' variant="contained" sx={{my:2}} onClick={() => navigate('/login')}>
                                        Checkout
                                    </Button>
                                </Grid>
                            }
                        </Grid>
                    </Grid>
                </Grid>

            :   <CarritoVacio />
            }
        </LayoutCrearDoc>
    )
}
    
































//     const cliente = JSON.parse(localStorage.getItem('cliente') ) || '';
//     const dispatch = useDispatch();

//     const { uid } = useSelector( state => state.authCliente );
//     const { carritoCliente } = useSelector( state => state.carrito );
//     const { totalCliente, totalDistri, iva, subTotalCliente } = usePrecioCarritoCliente();

//     const [cargando, setCargando] = useState(false);

    
//     const [formOp, setFormOp] = useState({
//         cliente: uid, 
//         totalOrden: 0,
//         totalCliente: 0,
//         totalDistri: 0,
//         iva: 0,
//         infoPersonal: "",
//         start: ''
//     });



//     useEffect(() => {
//         if(carritoCliente) {
//             setFormOp( (formOp) => ({
//                 ...formOp,
//                 cliente: uid, 
//                 infoPersonal: { ...cliente, uid: cliente.id },
//                 totalCliente: redondearNumero(totalCliente),
//                 totalDistri: redondearNumero(totalDistri),
//                 totalOrden: redondearNumero(totalCliente),
//                 iva
//             }));
//         }
//     }, [carritoCliente, totalCliente, totalDistri, iva] );




//     const eliminarItemCarrito = (id) => {
//         dispatch( carritoStartDeleteCliente(id) );
//     }



//     const handleCrearOp = async() => {
//         setCargando( true );
//         const resp = await dispatch( opStartAddNewCliente( formOp ) );
//         setCargando( false );
//         if( resp ){
//             localStorage.removeItem('cliente');
//             localStorage.removeItem('iva');
//         }
//     }  



//     return (


//         <LayoutReturn titulo={`Pagar Orden`} url='/categorias'>

//         <BackdropScreen cargando={cargando} titulo='Espere por favor estamos generando su orden de pedido...' />

//         {(carritoCliente.length > 0)
//         ?   <Grid container mt={5} mb={7}>
//                 <Grid item xs={12} md={7} sx={{pr:{ xs:0, md:3}}}>

//                     {cliente && 
//                         <InformacionCliente urlEditar="/checkout-cliente" /> 
//                     }

//                     <CardsComprarAhora carritoCompra={carritoCliente} 
//                         urlCotiz="/cotizar" 
//                         urlDetalle="/detalle-item" 
//                         urlModificar="/detalle-producto"
//                         functionDelete={eliminarItemCarrito}
//                     />

//                     <Paper sx={{mt:2, p:2, height:'50px', display:'flex', alignItems:'center', justifyContent:'end'}}>
//                         <Typography variant="h4">
//                             Total: {`$${ separadorMillares(subTotalCliente)}` }
//                         </Typography>
//                     </Paper>
//                 </Grid>


//                 <Grid item xs={12} md={5} sx={{mt:{xs:5, md:0}}}>
//                     <PagoOrdenOp setFormOp={setFormOp} formOp={formOp} />
//                     <BotonesDeCompletarOrden funcion={handleCrearOp}  url="/checkout-cliente"
//                         setFormOp={setFormOp} formOp={formOp} 
//                     />
//                 </Grid>
//             </Grid>

//         :   <Grid container sx={{width:'100%', mt:-7}}>
//                 <CarritoVacio />
//             </Grid>
//         }

//         </LayoutReturn>

//     )

// }
